<template>
  <div>
    <h3 class="header-title">Learning Teacher</h3>
    <label>Let’s see your tuition teacher.</label>
    <br />
    <label
      >
      You have subscribed to the {{ user.packageName }} package, which is valid until  {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}}  {{ user.invoiceprice }} and 
      includes a limit of {{ check.NumberOfStudent }} students and <span v-if="check.TotalTeacher === 0">Unlimited</span><span v-else>{{ check.TotalTeacher }} </span> teachers.
      
      </label
    >
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your teacher !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
              >X ERROR ! Your subscription package has expired. Please renew
              your current subscription or upgrade to a new package.
            </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()"
              >Renew</CButton
            >
          </CCol>
        </CRow>
      </CAlert>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCol sm="12" class="mt-4">
        <CRow>
          <CCol sm="4">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
              @change="ApplyFilter()"
            />
          </CCol>
          <CCol sm="8" class="text-right">
            <CButton
              class="btn custom-btn-lgt mr-2"
              type="button"
              @click="OpenCreateManualTeacher()"
              ><CIcon name="cil-plus" />Create Teacher</CButton
            >
            <CButton
              class="btn custom-btn-lgt"
              type="button"
              @click="OpenCreateManual()"
              ><CIcon name="cil-plus" />Assign Teacher</CButton
            ></CCol
          >
        </CRow>
        <CRow>
          <CCol sm="3">
            <v-select
              v-model="selectedStatus"
              :options="statusOptions"
              label="Status"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <CCol sm="5"></CCol>
          <CCol sm="6"> </CCol>
        </CRow>
      </CCol>
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="
            user.validTo < currentDate
              ? FilteredTeachers.slice(0, 5)
              : FilteredTeachers
          "
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          :dark="dark"
          clickable-rows
          sorter
          pagination
        >
          <template #ID="{ item }">
            <td>
              {{ item.Id }}
            </td>
          </template>

          <template #Profile="{ item }">
            <td>
              <img
                v-if="item.profileImagePath == null"
                style="
                  border: 1px solid #eee;
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  object-fit: cover;
                "
                src="../assets/img/default.png"
                class="grey lighten-2 mt-2"
              />

              <img
                v-else
                style="
                  border: 3px solid #ddd;
                  background: #fff;
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  object-fit: cover;
                "
                :src="getPic(item)"
                class="grey lighten-2 mt-2"
              />
            </td>
          </template>

          <template #Name="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.Name }}
              </h6>
            </td>
          </template>

          <template #Email="{ item }">
            <td>
              {{ item.Email }}
            </td>
          </template>

          <template #Phone="{ item }">
            <td>
              {{ item.Phone }}
            </td>
          </template>

          <template #Status="{ item }">
            <td>
              {{ item.Status }}
            </td>
          </template>

          <template #Action="{ item }">
            <td>
              <CDropdown
                toggler-text="Action"
                class="m-2 btn-act"
                color="primary"
              >
                <CDropdownItem @click="OpenUpdate(item)">Edit</CDropdownItem>
                <CDropdownItem @click="OpenDelete(item)">Delete</CDropdownItem>
                <CDropdownItem @click.prevent="ViewCV(item, $event)">View CV</CDropdownItem>
              </CDropdown>
            </td>
          </template>
        </CDataTable>

        <CModal title="Assign Teacher" size="md" :show.sync="TeacherModal">
          <div>
            <h6><strong>ASSIGN AS TUTOR</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CCol sm="3"> Email </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="ParentEmail" />
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="AssignTutor()"
              >Proceed</CButton
            ></template
          >
        </CModal>

        <CModal
          title="Create Teacher"
          size="md"
          :show.sync="CreateTeacherModal"
          :close-on-backdrop="false"
          :close-on-esc="false"
        >
          <div>
            <h6><strong>FORM TEACHER</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CCol sm="3"> Name </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Name" />
                </CCol>
                <CCol sm="3"> Email </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Email" />
                </CCol>
                <CCol sm="3"> Phone </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Phone" />
                </CCol>
                <CCol sm="3"> Status </CCol>
                <CCol sm="9">
                  <v-select
                    v-model="selectedStatusTeacher"
                    :options="statusList"
                    label="name"
                    placeholder="--Choose Status--"
                    class="custom-vselect no-bordered"
                    @click.stop
                  ></v-select>
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="SubmitTeacherManual"
              >Proceed</CButton
            ></template
          >
        </CModal>

        <CModal
          title="Edit Teacher"
          size="md"
          :show.sync="EditTeacherModal"
          :close-on-backdrop="false"
          :close-on-esc="false"
        >
          <div>
            <h6><strong>FORM TEACHER</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CCol sm="3"> Name </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Names" />
                </CCol>
                <CCol sm="3"> Email </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Emails" />
                </CCol>
                <CCol sm="3"> Phone </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Phones" />
                </CCol>
                <CCol sm="3"> Status </CCol>
                <CCol sm="9">
                  <v-select
                    v-model="selectedStatusTeacher"
                    :options="statusList"
                    label="name"
                    placeholder="--Choose Status--"
                    class="custom-vselect no-bordered"
                    @click.stop
                  ></v-select>
                </CCol>
                <CCol sm="3" class="mt-2"> Rank </CCol>
                <CCol sm="9">
                  <v-select
                    v-model="selectedRank"
                    :options="rankList"
                    label="rank"
                    placeholder="--Choose Rank--"
                    class="custom-vselect no-bordered mt-2"
                    @click.stop
                  ></v-select>
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="UpdateTeacher()"
              >Proceed</CButton
            ></template
          >
        </CModal>

        <CModal title="Delete Teacher" size="md" :show.sync="InactiveModal">
          <div>
            Are you sure you want delete {{ teacherDetail.Name }} ?
            <br />
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="UpdateTeacherStatus(teacherDetail.Id)"
              >Proceed</CButton
            ></template
          >
        </CModal>

        <CModal style="position: relative; max-width: 600px; height: 900px; border-radius: 32px;" size="" :show.sync="ViewCVModal" title="View CV">
          <div class="ml-3 mr-3">
            <embed :src="fileUrl" type="application/pdf" width="100%" height="500px" />            
          </div>
          
          <br /> <br /> 
          <template #footer>
            <CButton color="success" @click="closeCV()">Close</CButton>
          </template> 
        </CModal>

        <CModal style="position: relative; max-width: 600px; height: 900px; border-radius: 32px;" size="" :show.sync="ViewNoCV" title="View CV">
          <div class="ml-3 mr-3">
            No CV        
          </div>
          
          <br /> <br /> 
          <template #footer>
            <CButton color="success" @click="closeCV()">Close</CButton>
          </template> 
        </CModal>
      </CCol>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-sweet-calendar/dist/SweetCalendar.css";
import vSelect from "vue-select";
import JwPagination from "jw-vue-pagination";
Vue.component("jw-pagination", JwPagination);

import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.use(VuejsDialog);

Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Tables",
  components: {
    PulseLoader,
  },
  data() {
    return {
      teachers: [],
      SearchQuery: "",
      FilteredTeachers: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,

      selectedStatus: "ALL STATUS",
      statusOptions: [],

      selectedRank: "ALL RANK",

      Busy: false,

      fields: [
        { key: "ID" },
        { key: "Profile" },
        { key: "Name" },
        { key: "Email" },
        { key: "Phone" },
        { key: "Status" },
        { key: "Action" },
      ],

      TeacherModal: false,
      EditTeacherModal: false,

      Name: "",
      Phones: "",
      Emails: "",

      teacherDetail: {},
      cv: {},

      InactiveModal: false,
      ViewCVModal:false,
      ViewNoCV : false,
      fileUrl: "",
      assign: "",
      parents: [],
      SelectedParent: "",
      ParentEmail: "",
      selectedStatusTeacher: {},
      statusList: [
        {
          name: "active",
        },
        {
          name: "deleted",
        },
        {
          name: "removed",
        },
        {
          name: "registered",
        },
      ],
      rankList: [
        {
          rank: 0,
        },
        {
          rank: 1,
        },
        {
          rank: 2,
        },
        {
          rank: 3,
        },
        {
          rank: 4,
        },
      ],
      ErrorMessage: true,
      user: {},
      small: "",
      fixed: "",
      currentDate: new Date().toISOString().substring(0, 10),

      Name: "",
      Email: "",
      Phone: "",

      CreateTeacherModal: false,
      check: {},
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetTeacher();
      this.GetParent();
      this.RefreshData();
      this.GetCheckTc();
      this.ViewCV();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},
  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },

    RefreshData() {
      this.GetTeacher();
    },
    onModalClose(event) {
      // Check if the selected value is the last item in the statusList
      const lastIndex = this.statusList.length - 1;
      const lastItem = this.statusList[lastIndex];
      const isSelectedLastItem =
        this.selectedStatusTeacher &&
        this.selectedStatusTeacher.name === lastItem.name;

      // If the selected value is the last item, prevent the modal window from closing
      if (isSelectedLastItem) {
        event.stopPropagation(); // Stop the close event propagation
        return false; // Prevent the modal from closing
      }

      // If the selected value is not the last item, allow the modal window to close
      this.EditTeacherModal = false;
    },
    GetTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teachers = response.data;
            if (this.user.totalTeacher === 0) {
              // Set this.teachers to unlimited
              this.teachers = this.teachers;
            } else {
              // Set this.teachers based on the value of this.user.totalTeacher
              this.teachers = this.teachers.slice(0, this.user.totalTeacher);
            }
            
            this.getPic(this.teachers);
            this.FilteredTeachers = this.teachers;

            var statusNames = _.uniq(_.map(response.data, "Status"));
            statusNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.statusOptions = statusNames;
            this.statusOptions.unshift("ALL STATUS");
          }
        });
    },
    GetParent() {
      this.Busy = true;
      this.$API
        .get(this.$GetListParent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parents = response.data;
          }
        });
    },

    // GetCV() {
    //   this.Busy = true;
    //   this.$API
    //     .get(this.$GetTeacherCV + "?teacherId=" + this.teacherId, {
    //       withCredentials: true,
    //     })

    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.cv = response.data;
    //         console.log("testcv", this.cv);
    //       }
    //     });
    // },

    ApplyFilter: function () {
      var arr = _.orderBy(this.teachers, ["Name"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Name, Phone, Email }) =>
          _.some([
            _.includes(!Name || Name.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
            _.includes(!Phone || Phone.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
            _.includes(!Email || Email.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredTeachers = result;
      }
    },
    getPic(item) {
      return "https://pickiddo.com" + item.profileImagePath;
    },
    FilteredData() {
      console.log("masuk");
      this.FilteredTeachers = this.teachers;

      if (this.selectedStatus !== "ALL STATUS")
        this.FilteredTeachers = _.filter(
          this.FilteredTeachers,
          (item) => item.Status === this.selectedStatus
        );
    },
    OpenCreateManual() {
      this.TeacherModal = true;
    },
    OpenCreateManualTeacher() {
      this.CreateTeacherModal = true;
    },
    async SubmitTeacherManual() {
      console.log("test" + this.check.CurrentCountTeacher);
      console.log("test1" + this.check.TotalTeacher);

        const formData = new FormData();

        formData.append("Name", this.Name);
        formData.append("Email", this.Email);
        formData.append("Phone", this.Phone);
        formData.append("UserType", "teacher");

        formData.append("PasswordHash", "cellnet777#");
        formData.append("countTotalTeacher", this.check.CurrentCountTeacher);

        return this.$API
          .post(this.$InsertRegisterTeacher, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.Busy = false;
              this.$dialog.alert("Success saved").then(function () {});
              this.CreateTeacherModal = false;
              this.GetTeacher();
            } else {
              this.Busy = false;
              this.$dialog.alert("Error!Please contact developer").then(function () {});
              this.CreateTeacherModal = false;
              this.GetTeacher();
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
        
      },
    AssignTutor: function () {
      const formData = new FormData();

      formData.append("Email", this.ParentEmail);
      formData.append("UserType", "teacher");

      return this.$API
        .post(this.$AssignTeacher, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.TeacherModal = false;
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to saved ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenUpdate(item) {
      this.teacherId = item.UserId;

      this.$API
        .get(this.$GetTeacherById + "?teacherId=" + this.teacherId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.Names = this.info.Name;
            this.Phones = this.info.Phone;
            this.Emails = this.info.Email;
            this.Statuses = this.info.Status;
            this.Ranks = this.info.Rank;

            this.SetupSelectedOption();
            this.EditTeacherModal = true;
          }
        });
    },

    SetupSelectedOption() {
      this.selectedStatusTeacher = _.find(this.statusList, {
        name: this.Statuses,
      });
      this.selectedRank = _.find(this.rankList, {
        rank: this.Ranks,
      });
    },
    UpdateTeacher: function () {
      const formData = new FormData();
      formData.append("Id", this.teacherId);
      formData.append("Name", this.Names);
      formData.append("Phone", this.Phones);
      formData.append("Email", this.Emails);
      formData.append("Status", this.selectedStatusTeacher.name);
      formData.append("Rank", this.selectedRank.rank);

      return this.$API
        .post(this.$UpdateTeacher, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.EditTeacherModal = false;
            this.RefreshData();
            this.$dialog.alert("Success to save ").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to create subject ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenDelete(item) {
      this.teacherId = item.Id;
      this.userId = item.UserId;

      this.$API
        .get(this.$GetTeacherById + "?teacherId=" + this.userId, {
          withCredentials: true,
        })

        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherDetail = response.data;
          }
        });
      this.InactiveModal = true;
    },

    ViewCV(item, event) {
      this.teacherId = item.Id;
      event.preventDefault();
      

      this.$API
        .get(this.$GetTeacherCV + "?teacherId=" + this.teacherId, {
          withCredentials: true,
        })

        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.cv = response.data;
            console.log("testcv", this.cv);
            this.fileUrl = this.cv.FilePath;
            console.log("testpath", this.fileUrl);
            if (this.cv == "No CV")
            {
              this.ViewNoCV = true;              
            }
            else {
              this.ViewCVModal = true;
            }
          }
        });

      
    },

    closeCV() {
      this.GetTeacher();
      this.ViewCVModal = false;   
      this.ViewNoCV = false;     
    },

    UpdateTeacherStatus: function () {
      const formData = new FormData();
      formData.append("Id", this.teacherId);
      formData.append("Status", "deleted");

      return this.$API
        .post(this.$UpdateTeacherStatus, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.InactiveModal = false;
            this.$dialog.alert("Success saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to update ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GoToRenew() {
      // window.open(
      //   "https://www.pickiddo.com/RenewPackage?UserGroupId=" +
      //     this.user.usergroupId,
      //   "_blank"
      // );
      this.$router.push(
        "/Billing"
      );
    },
  },
};
</script>
<style>
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
.custom-btn-lgt {
  background: #7460ee;
  border: 1px solid #7460ee;
  color: #ffffff;
  width: 230px;
}
.btn-act {
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #7460ee;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.btn-primary {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
.btn-primary:hover {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
</style>
